if (document.querySelector('input[name="subscribe"]')) {
  document
    .querySelector('input[name="subscribe"]')
    .setAttribute("checked", true);
  document.querySelector('input[name="subscribe"]').onchange();
}
function changeCurrency() {
  document.getElementById("FooterCountryFormH").submit();
}
document.addEventListener("DOMContentLoaded", function () {
  if (document.querySelector(".close-announcement-bar-wrapper a")) {
    document
      .querySelector(".close-announcement-bar-wrapper a")
      .addEventListener("click", function (e) {
        e.preventDefault();
        e.target.closest(".custom-announcement-bar-wrapper").style.display =
          "none";
        document.querySelector(".header-wrapper").style.top = "0";
      });
  }
});
if (document.querySelector(".instagram-section-wrapper")) {
  var instagramSectionPos =
    document.querySelector(".instagram-section-wrapper").offsetTop - 150;
  var instagramSectionHeight = document.querySelector(
    ".instagram-section-wrapper",
  ).offsetHeight;
  var bottomSectionHeight =
    parseInt(instagramSectionPos) + parseInt(instagramSectionHeight);
  var lastScrollTop = 0;
  window.addEventListener(
    "scroll",
    function () {
      // or window.addEventListener("scroll"....
      let scrollPos = this.scrollY;
      var st = window.pageYOffset || document.documentElement.scrollTop;
      if (st > lastScrollTop) {
        if (
          scrollPos >= instagramSectionPos &&
          scrollPos <= bottomSectionHeight
        ) {
          var instagramPosts = document.querySelectorAll(
            ".instagram-section-wrapper .custom-instagram-single-image",
          );
          instagramPosts.forEach(function (el, key) {
            el.classList.remove("cancelTranslate");
            el.classList.remove("downTranslate");
            el.classList.add("upTranslate");
          });
        }
      } else {
        if (
          scrollPos >= instagramSectionPos &&
          scrollPos <= bottomSectionHeight
        ) {
          var instagramPosts = document.querySelectorAll(
            ".instagram-section-wrapper .custom-instagram-single-image",
          );
          instagramPosts.forEach(function (el, key) {
            el.classList.remove("cancelTranslate");
            el.classList.remove("upTranslate");
            el.classList.add("downTranslate");
          });
        }
      }
      lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
    },
    false,
  );
}
